import { useTranslation } from "react-i18next";
import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import emailjs from "@emailjs/browser";
import "./ContactStyle.css";

const ContactSection = ({ id }) => {
  const { t } = useTranslation();
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus(t("contact.fill_required"));
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setStatus(t("contact.invalid_email"));
      return;
    }

    const currentTime = new Date().toLocaleString();
    const hiddenTimeInput = form.current.querySelector('input[name="time"]');
    if (hiddenTimeInput) hiddenTimeInput.value = currentTime;

    setIsLoading(true);
    setStatus("");

    const serviceID = "service_357tc09";
    const templateID = "template_b2rtx1l";
    const publicKey = "iqcjdUbfpjtp7-_eY";

    emailjs.sendForm(serviceID, templateID, form.current, publicKey).then(
      (result) => {
        console.log(result.text);
        setStatus(t("contact.success"));
        setFormData({ name: "", email: "", phone: "", message: "" });
        setIsLoading(false);
        setTimeout(() => setStatus(""), 3000);
      },
      (error) => {
        console.log(error.text);
        setStatus(t("contact.error"));
        setIsLoading(false);
        setTimeout(() => setStatus(""), 3000);
      }
    );
  };

  return (
    <section id={id} className="contact-section">
      <div className="contact-content">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>{t("contact.title")}</h2>
            <p>{t("contact.description")}</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/share/1Ecmj1AWs9/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://www.instagram.com/ali.mnshay123123?igsh=dzc1MTc3bHkxZTJp&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>

          <div className="contact-form-container">
            <form ref={form} className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group half-width">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t("contact.name_placeholder")}
                    required
                  />
                </div>
                <div className="form-group half-width">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={t("contact.phone_placeholder")}
                  />
                </div>
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("contact.email_placeholder")}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder={t("contact.message_placeholder")}
                  required
                />
              </div>
              <input type="hidden" name="time" />
              <button
                type="submit"
                className={`submit-btn ${isLoading ? "loading" : ""}`}
                disabled={isLoading}
              >
                {isLoading ? t("contact.sending") : t("contact.submit")}
              </button>
              {status && (
                <p
                  className={`form-status ${
                    status.includes("success") ? "success" : "error"
                  }`}
                >
                  {status}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
